// Bild-Vorschau innerhalb einer Chat-Nachricht — lädt die signierte URL erst beim Anzeigen.
import { useEffect, useState } from 'react';
import { SpinnerGap } from '@phosphor-icons/react';
import { bildUrl } from '../../../../lib/chat/api';

/** Bild einer Nachricht — die signierte URL wird erst beim Anzeigen geholt. */
export function ChatBild({ path, name, onGross }: {
  path: string; name: string | null; onGross: (b: { url: string; path: string; name: string | null }) => void;
}) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let weg = false;
    void bildUrl(path).then((u) => { if (!weg) setUrl(u); });
    return () => { weg = true; };
  }, [path]);
  if (!url) {
    return (
      <span className="flex items-center justify-center" style={{ width: 128, height: 96, borderRadius: 14, background: 'rgba(255,255,255,0.06)' }}>
        <SpinnerGap size={14} className="pille-dreh" color="rgba(255,255,255,0.4)" />
      </span>
    );
  }
  return (
    <button type="button" onClick={() => onGross({ url, path, name })} className="block cursor-pointer" title="Vollbild öffnen"
      style={{ border: 'none', padding: 0, background: 'transparent' }}>
      <img src={url} alt={name || 'Bild'} className="object-cover" style={{ maxHeight: 176, maxWidth: 220, borderRadius: 14 }} />
    </button>
  );
}
